import { format } from 'date-fns'

export function formatDate(date: Date) {
  return format(date, 'dd/MM/yyyy')
}
export function formatDateAndTime(date: Date) {
  return format(date, 'dd/MM/yyyy HH:mm')
}

// Mantém apenas AAAA-MM-DD (10 chars). Se maior, corta; se tiver texto junto, extrai o 1º match.
export function sanitizeDate(v: string | null | undefined): string {
  if (!v) return ''
  const s = String(v).trim()
  const m = s.match(/\d{4}-\d{2}-\d{2}/)
  if (m) return m[0] // primeiro match válido
  return s.slice(0, 10) // fallback: corta nos 10 primeiros
}
